import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromClipboard from '@app/store/reducers/clipboard.reducer';

export const selectClipboardState =
  createFeatureSelector<fromClipboard.ClipboardState>('clipboard');

export const selectClipboard = createSelector(selectClipboardState, (state) => state);
